import '../assets/css/heatmap.css'

import { ApexOptions } from 'apexcharts'
import { memo } from 'react'
import ReactApexChart from 'react-apexcharts'

import styles from '../assets/css/components/Heatmap.module.css'
import { divideScale } from '../utils/display'
import DataNotFound from './DataNotFound'

export interface HeatmapProps {
  series: {
    name: string
    data: {
      x: string
      y: number
    }[]
  }[]
  max: number
  height: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Heatmap = memo(({ series, max, height = '33vh' }: HeatmapProps) => {
  if (series.every((s) => s.data.every((d) => d.y === 0 || d.y === -1))) {
    return <DataNotFound className={`${height}`} />
  }
  const colorScale = divideScale(0, max, 5)
  const options: ApexOptions = {
    chart: {
      offsetY: -25,
      toolbar: {
        show: false,
      },
      type: 'heatmap',
    },
    legend: {
      show: true,
      position: 'bottom',
      offsetY: 5,
    },
    tooltip: {
      followCursor: true,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
      custom({ seriesIndex, dataPointIndex, w }: { seriesIndex: number; dataPointIndex: number; w: any }) {
        const value = w.globals.series[seriesIndex][dataPointIndex]
        const formattedValue = (typeof value === 'number' && value !== -1) ? value.toLocaleString() : 'データなし'
        const suffix = (typeof value === 'number' && value !== -1 ) ? '人' : ''
        return `<div class="tooltip">
                  <span>
                    ${w.globals.labels[dataPointIndex]} ${w.config.series[seriesIndex].name} : ${formattedValue}${suffix}
                  </span>
                </div>`
      },
      enabled: true
    },
    plotOptions: {
      heatmap: {
        enableShades: true,
        shadeIntensity: 0.5,
        colorScale: {
          inverse: false,
          ranges: [
            {
              from: -1,
              to: -1,
              color: '#696969',
            },
            {
              from: colorScale[0],
              to: colorScale[1],
              color: '#E6FFE6',
              name: `来訪回数: ${  colorScale[0]  } - ${  (colorScale[1]).toLocaleString()  }`
            },
            {
              from: colorScale[1] + 1,
              to: colorScale[2],
              color: '#99FF99',
              name: `来訪回数: ${  (colorScale[1] + 1).toLocaleString()  } - ${  (colorScale[2]).toLocaleString()  }`
            },
            {
              from: colorScale[2] + 1,
              to: colorScale[3],
              color: '#33FF33',
              name: `来訪回数: ${  (colorScale[2] + 1).toLocaleString()  } - ${  (colorScale[3]).toLocaleString()  }`
            },
            {
              from: colorScale[3] + 1,
              to: colorScale[4],
              color: '#00CC00',
              name: `来訪回数: ${  (colorScale[3] + 1).toLocaleString()  } - ${  (colorScale[4]).toLocaleString()  }`
            },
            {
              from: colorScale[4],
              to: colorScale[5],
              color: '#006600',
              name: `来訪回数: ${  (colorScale[4] + 1).toLocaleString() } - ${  (colorScale[5]).toLocaleString()  }`
            },
          ],
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    // X軸のツールチップ非表示
    xaxis: {
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      title: {
        // text: '時間帯',
        rotate: 0,
        offsetX: 0,
        offsetY: -10,
        style: {
          fontSize: '12px',
          fontWeight: 600,
          cssClass: 'apexcharts-yaxis-title',
        },
      },
    },
  }

  return (
    <div className={`${styles.heatmapContainer} ${height}`}>
      <div className={styles.yaxisLabel}>時間帯</div>
      <ReactApexChart options={options} series={series} type='heatmap' height='100%' />
    </div>
  )
})

export default Heatmap